var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "transfer-client-modal", "modal-dialog-scrollable": false },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("global.words.move")) +
                " " +
                _vm._s(_vm.clientProfileName) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "form",
              {
                attrs: { id: "transfer-client-form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.handleSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group-material" },
                  [
                    _c("select2", {
                      ref: "select",
                      attrs: {
                        id: "transfer-board-select",
                        data: _vm.boards,
                        name: "board-select",
                        options: _vm.options,
                        "format-data": _vm.formatData,
                      },
                      on: { change: _vm.handleChange },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "bar" }),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                ref: "submitButton",
                staticClass: "btn btn-primary btn-sm",
                attrs: {
                  type: "submit",
                  form: "transfer-client-form",
                  disabled: !_vm.selectedBoardId,
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$tc("boards.actions.moveClient", 1)) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }